import React, { Fragment } from 'react';

import logoSprite from './logo.svg';
import './index.scss';

const ProdigyLogo = () => {
  return (
    <Fragment>
      <svg className="prodigy-logo prodigy-logo--inline">
        <use xlinkHref={`${logoSprite}#logo-inline`} />
      </svg>

      <svg className="prodigy-logo">
        <use xlinkHref={`${logoSprite}#logo`} />
      </svg>
    </Fragment>
  );
};

export default ProdigyLogo;
